import './Tag.css';
import moment from 'moment'
import React from 'react';

class Tag extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timeAgoString: moment(this.props.read.time*1000).fromNow()
    };
  }

  componentDidMount(){
    // add the interval
    this.interval = setInterval(this.updateReminderTime.bind(this), 3000);
  }

  componentWillUnmount(){
    // remove the interval listener
    clearInterval(this.interval);
  }

  updateReminderTime() {
    this.setState({timeAgoString: moment(this.props.read.time*1000).fromNow()});
  }

  render() {
    var time = moment(this.props.read.time*1000);
    var timeString = time.format('H:mm:ss');

    var rssi = parseInt(this.props.read.rssi);
    var rssiPercentage = (rssi+100+15);



    return(
      <div className="tag-item">
        <div className="tag-info">
          <div><strong>{this.props.read.tag}</strong></div>
          <div className="time">{this.state.timeAgoString} ({timeString})</div>
        </div>
        <div className="rssi-and-antenna-container">
          <div className="rssi-container">
            <div className="rssi-label">RSSI:</div>
            <div className="rssi-bar" style={{ '--rssi-value': rssiPercentage }}></div>
            <div className="rssi-value">{rssi} dBm</div>
          </div>
          <div className="antenna">
            antenna {this.props.read.antenna}
          </div>
        </div>
        {this.props.read.player && (
        <div className="player-info">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>{this.props.read.player.startnr} - {this.props.read.player.searchName} (wave {this.props.read.player.wave})</span>
            <span>{this.props.read.player.agegroup}</span>
          </div>
        </div>
        )}
      </div>
    );
  }


}

export default Tag
